

import React, { useEffect, useState } from 'react'
import { getDashReports, getRevenueDownload } from '../../services/reports'
import { useParams, useNavigate } from 'react-router-dom'
import { 
  DatePicker, 
  Space, 
  Card, 
  Button, 
  Row, 
  Col, 
  Statistic,
  Modal,
  Form,
  Input,
  TimePicker,
  Select,
  InputNumber,
  message,
  Spin,
  Table,
  Tag,
  Tooltip,
  Divider,
  Avatar,
  Dropdown,
  Badge,
  Typography,
  Drawer,
  List
} from 'antd';
import {
  DollarCircleOutlined,
  UserOutlined,
  StarOutlined,
  PlusOutlined,
  CalendarOutlined,
  PhoneOutlined,
  MailOutlined,
  TeamOutlined,
  ClockCircleOutlined,
  UserAddOutlined,
  EditOutlined,
  EyeOutlined,
  MoreOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ShoppingCartOutlined,
  HistoryOutlined,
  SearchOutlined,
  CloseOutlined,
  WalletOutlined,
  CreditCardOutlined,
  DownloadOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { createAppoinment, getAppoinmentStats, getTodaysAppoinment, updateAppoinment, updateAppoinmentStatus } from '../../services/appoinmentApi';
import { getServiceApi } from '../../services/serviceApi';
import { getAllUsersApi } from '../../services/users';
import { createOrderApi } from '../../services/orderApi';
import { getMembers, getMemberUsageHistory } from '../../services/memberService';
import { toast } from 'react-toastify';
import ExpensesOverview from '../expenses/expenseOverView';

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Title, Text } = Typography;

export default function CompanyDashBoardHome() {
  const today = moment().format('DD/MM/YYYY');
  const [reports, setReports] = useState({})
  const [loading, setLoading] = useState(false)
  const [appointments, setAppointments] = useState({
    totalThisMonth: 0,
    totalToday: 0,
    todaysBookings: []
  })
  const [appointmentsLoading, setAppointmentsLoading] = useState(false)
  const [bookingModalVisible, setBookingModalVisible] = useState(false)
  const [bookingLoading, setBookingLoading] = useState(false)
  const [filterDate, setFilterDate] = useState({
    startDate: today,
    endDate: today
  });

  // New states for booking management
  const [monthlyBookingsVisible, setMonthlyBookingsVisible] = useState(false)
  const [monthlyBookings, setMonthlyBookings] = useState([])
  const [monthlyBookingsLoading, setMonthlyBookingsLoading] = useState(false)
  const [editBookingModal, setEditBookingModal] = useState(false)
  const [selectedBooking, setSelectedBooking] = useState(null)
  const [editForm] = Form.useForm()
  
  // Order creation states
  const [createOrderModal, setCreateOrderModal] = useState(false)
  const [services, setServices] = useState([])
  const [staffList, setStaffList] = useState([])
  const [selectedServices, setSelectedServices] = useState([])
  const [orderLoading, setOrderLoading] = useState(false)
  
  // Enhanced service search and filter states
  const [serviceSearchTerm, setServiceSearchTerm] = useState('')
  const [servicePriceFilter, setServicePriceFilter] = useState(null)
  const [serviceSortBy, setServiceSortBy] = useState('name')
  const [filteredServices, setFilteredServices] = useState([])

  // Users / Members section
  const [members, setMembers] = useState([])
  const [membersLoading, setMembersLoading] = useState(false)
  const [memberSearch, setMemberSearch] = useState('')
  const [historyDrawerOpen, setHistoryDrawerOpen] = useState(false)
  const [selectedMember, setSelectedMember] = useState(null)
  const [memberHistory, setMemberHistory] = useState([])
  const [historyLoading, setHistoryLoading] = useState(false)

  const navigate = useNavigate();
  const [form] = Form.useForm();
  let { companyId } = useParams()

  useEffect(() => {
    getCompanyDashReports()
    getAppointmentStats()
  }, [filterDate])

  useEffect(() => {
    fetchMembers()
  }, [])

  const fetchMembers = async () => {
    setMembersLoading(true)
    try {
      const res = await getMembers({ companyId })
      setMembers(res?.data || [])
    } catch (err) {
      console.error('Error fetching members:', err)
    } finally {
      setMembersLoading(false)
    }
  }

  const openHistoryDrawer = async (member) => {
    setSelectedMember(member)
    setHistoryDrawerOpen(true)
    setHistoryLoading(true)
    try {
      const res = await getMemberUsageHistory(member._id)
      setMemberHistory(res?.data || [])
    } catch (err) {
      console.error('Error fetching history:', err)
      setMemberHistory([])
    } finally {
      setHistoryLoading(false)
    }
  }

  const downloadMembersCSV = () => {
    const headers = ['Name', 'Email', 'Phone', 'Total Visits', 'Total Spent (₹)', 'Status', 'Joined']
    const rows = members.map(m => [
      m.name || '',
      m.email || '',
      m.phone || '',
      m.totalVisits || 0,
      m.totalSpent || 0,
      m.status || '',
      m.createdAt ? moment(m.createdAt).format('DD/MM/YYYY') : '',
    ])
    const csvContent = [headers, ...rows]
      .map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','))
      .join('\n')
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `users_${companyId}_${moment().format('YYYYMMDD')}.csv`
    link.click()
    URL.revokeObjectURL(url)
  }

  const getCompanyDashReports = async () => {
    setLoading(true)
    try {
      let res = await getDashReports({ 
        companyId: companyId, 
        startDate: filterDate.startDate, 
        endDate: filterDate.endDate 
      })
      console.log(res, "response list")
      if (res) setReports(res || {})
    } catch (error) {
      console.error('Error fetching reports:', error)
    } finally {
      setLoading(false)
    }
  }

  const getAppointmentStats = async () => {
    setAppointmentsLoading(true)
    try {
      const startOfMonth = moment().startOf('month').format('DD/MM/YYYY')
      const endOfMonth = moment().endOf('month').format('DD/MM/YYYY')
      const today = moment().format('DD/MM/YYYY')
      
      console.log('Fetching appointment stats...', { startOfMonth, endOfMonth, today, companyId });
      
      const [monthlyRes, todayRes, todaysBookingsRes] = await Promise.allSettled([
        getAppoinmentStats({companyId: companyId, startDate: startOfMonth, endDate: endOfMonth}),
        getAppoinmentStats({companyId: companyId, startDate: today, endDate: today}),
        getTodaysAppoinment({companyId: companyId, date: today})
      ])
      
      let monthlyData = { data: { totalAppointments: 0 } }
      let todayData = { data: { totalAppointments: 0 } }
      let todaysBookings = { data: [] }
      
      if (monthlyRes.status === 'fulfilled' && monthlyRes.value?.success) {
        monthlyData = monthlyRes.value
      }
      
      if (todayRes.status === 'fulfilled' && todayRes.value?.success) {
        todayData = todayRes.value
      }
      
      if (todaysBookingsRes.status === 'fulfilled' && todaysBookingsRes.value?.success) {
        todaysBookings = todaysBookingsRes.value
      }
      
      setAppointments({
        totalThisMonth: monthlyData?.data?.totalAppointments || 0,
        totalToday: todayData?.data?.totalAppointments || 0,
        todaysBookings: todaysBookings?.data || []
      })
      
    } catch (error) {
      console.error('Error fetching appointment stats:', error)
      setAppointments({
        totalThisMonth: 0,
        totalToday: 0,
        todaysBookings: []
      })
    } finally {
      setAppointmentsLoading(false)
    }
  }
const downloadReport = async () => {
  try {
    setLoading(true);
    
    // Call your download report API
    const response = await getRevenueDownload({ 
      companyId: companyId, 
      startDate: filterDate.startDate, 
      endDate: filterDate.endDate
    });
    
    if (!response || !response.data) {
      message.error('No data available for download');
      return;
    }
    
    // Convert data to CSV format
    const csvData = convertToCSV(response.data);
    
    // Create and download CSV file
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `company-report-${filterDate.startDate}-to-${filterDate.endDate}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    message.success('Report downloaded successfully!');
    
  } catch (error) {
    console.error('Error downloading report:', error);
    message.error('Failed to download report. Please try again.');
  } finally {
    setLoading(false);
  }
};

const convertToCSV = (data) => {
  // Define CSV headers based on the downloadCompanyReport API response
  const headers = [
    'Date',
    'Total Customers',
    'Online Amount',
    'Cash Amount (Offline)',
    'Total Amount',
    'Online Count',
    'Cash Count (Offline)'
  ];
  
  // Create CSV rows from the data array
  const rows = [];
  
  // Check if data is an array (day-by-day breakdown from downloadCompanyReport)
  if (Array.isArray(data)) {
    data.forEach(dayData => {
      rows.push([
        dayData.date || '',
        dayData.totalCustomers || 0,
        dayData.onlineAmount || 0,
        dayData.cashAmount || 0,
        dayData.totalAmount || 0,
        dayData.onlineCount || 0,
        dayData.cashCount || 0
      ]);
    });
  } else {
    // If data is not an array, create a single summary row
    rows.push([
      `${filterDate.startDate} to ${filterDate.endDate}`,
      data.totalCustomers || 0,
      data.paymentModeStats?.online?.amount || 0,
      data.paymentModeStats?.cash?.amount || 0,
      data.totalAmount || 0,
      data.paymentModeStats?.online?.count || 0,
      data.paymentModeStats?.cash?.count || 0
    ]);
  }
  
  // Add totals row if we have multiple days
  if (Array.isArray(data) && data.length > 1) {
    const totals = data.reduce((acc, day) => ({
      totalCustomers: acc.totalCustomers + (day.totalCustomers || 0),
      onlineAmount: acc.onlineAmount + (day.onlineAmount || 0),
      cashAmount: acc.cashAmount + (day.cashAmount || 0),
      totalAmount: acc.totalAmount + (day.totalAmount || 0),
      onlineCount: acc.onlineCount + (day.onlineCount || 0),
      cashCount: acc.cashCount + (day.cashCount || 0)
    }), {
      totalCustomers: 0,
      onlineAmount: 0,
      cashAmount: 0,
      totalAmount: 0,
      onlineCount: 0,
      cashCount: 0
    });
    
    // Add separator and totals row
    rows.push(['', '', '', '', '', '', '']); // Empty row
    rows.push([
      'TOTAL',
      totals.totalCustomers,
      totals.onlineAmount,
      totals.cashAmount,
      totals.totalAmount,
      totals.onlineCount,
      totals.cashCount
    ]);
  }
  
  // Convert to CSV string
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.map(cell => {
      // Handle cells that might contain commas by wrapping in quotes
      if (typeof cell === 'string' && cell.includes(',')) {
        return `"${cell}"`;
      }
      return cell;
    }).join(','))
  ].join('\n');
  
  return csvContent;
};

// const convertToCSV = (data) => {
//   // Define CSV headers based on your API response structure
//   const headers = [
//     'Metric',
//     'Value',
//     'Date Range',
//     'Currency'
//   ];
  
//   // Create CSV rows from the data
//   const rows = [];
  
//   // Add total amount
//   rows.push(['Total Amount', data.totalAmount || 0, `${filterDate.startDate} to ${filterDate.endDate}`, 'INR']);
  
//   // Add repeat clients if available
//   if (data.repeatClients !== undefined) {
//     rows.push(['Repeat Clients', data.repeatClients, `${filterDate.startDate} to ${filterDate.endDate}`, 'Count']);
//   }
  
//   // Add payment mode stats
//   if (data.paymentModeStats) {
//     if (data.paymentModeStats.online) {
//       rows.push(['Online Payments', data.paymentModeStats.online.amount || 0, `${filterDate.startDate} to ${filterDate.endDate}`, 'INR']);
//       rows.push(['Online Payment Count', data.paymentModeStats.online.count || 0, `${filterDate.startDate} to ${filterDate.endDate}`, 'Count']);
//     }
    
//     if (data.paymentModeStats.cash) {
//       rows.push(['Cash Payments', data.paymentModeStats.cash.amount || 0, `${filterDate.startDate} to ${filterDate.endDate}`, 'INR']);
//       rows.push(['Cash Payment Count', data.paymentModeStats.cash.count || 0, `${filterDate.startDate} to ${filterDate.endDate}`, 'Count']);
//     }
//   }
  
//   // Add top service if available
//   if (data.topService) {
//     rows.push(['Top Service Name', data.topService.name || 'N/A', `${filterDate.startDate} to ${filterDate.endDate}`, 'Text']);
//     rows.push(['Top Service Orders', data.topService.count || 0, `${filterDate.startDate} to ${filterDate.endDate}`, 'Count']);
//   }
  
//   // Add appointment stats
//   rows.push(['Monthly Appointments', appointments.totalThisMonth, `${filterDate.startDate} to ${filterDate.endDate}`, 'Count']);
//   rows.push(['Today Appointments', appointments.totalToday, `${filterDate.startDate} to ${filterDate.endDate}`, 'Count']);
  
//   // Convert to CSV string
//   const csvContent = [headers.join(','), ...rows.map(row => row.join(','))].join('\n');
  
//   return csvContent;
// };
  const fetchMonthlyBookings = async () => {
    setMonthlyBookingsLoading(true)
    try {
      const startOfMonth = moment().startOf('month').format('DD/MM/YYYY')
      const endOfMonth = moment().endOf('month').format('DD/MM/YYYY')
      
      // Use the updated API with date range
      const res = await getTodaysAppoinment({
        companyId: companyId, 
        startDate: startOfMonth,
        endDate: endOfMonth
      })
      
      if (res?.success) {
        setMonthlyBookings(res.data || [])
      }
    } catch (error) {
      console.error('Error fetching monthly bookings:', error)
      message.error('Failed to fetch monthly bookings')
    } finally {
      setMonthlyBookingsLoading(false)
    }
  }

  const fetchServices = async () => {
    try {
      const res = await getServiceApi({companyId: companyId});
      setServices(res || []);
      setFilteredServices(res || []); // Initialize filtered services
    } catch (err) {
      message.error("Failed to fetch services");
    }
  };

  // Enhanced service filtering and sorting
  useEffect(() => {
    let filtered = [...services];

    // Apply search filter
    if (serviceSearchTerm) {
      filtered = filtered.filter(service =>
        service.name.toLowerCase().includes(serviceSearchTerm.toLowerCase()) ||
        (service.description && service.description.toLowerCase().includes(serviceSearchTerm.toLowerCase()))
      );
    }

    // Apply price filter
    if (servicePriceFilter) {
      filtered = filtered.filter(service => {
        const price = service.price;
        switch (servicePriceFilter) {
          case '0-500':
            return price >= 0 && price <= 500;
          case '500-1000':
            return price > 500 && price <= 1000;
          case '1000-2000':
            return price > 1000 && price <= 2000;
          case '2000-5000':
            return price > 2000 && price <= 5000;
          case '5000+':
            return price > 5000;
          default:
            return true;
        }
      });
    }

    // Apply sorting
    filtered.sort((a, b) => {
      switch (serviceSortBy) {
        case 'name':
          return a.name.localeCompare(b.name);
        case 'name-desc':
          return b.name.localeCompare(a.name);
        case 'price':
          return a.price - b.price;
        case 'price-desc':
          return b.price - a.price;
        default:
          return 0;
      }
    });

    setFilteredServices(filtered);
  }, [services, serviceSearchTerm, servicePriceFilter, serviceSortBy]);

  const fetchStaff = async () => {
    try {
      const res = await getAllUsersApi({ companyId });
      setStaffList(res || []);
    } catch (err) {
      console.error("Error fetching staff", err);
    }
  };

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleChange = (e, dates) => {
    const formattedStart = formatDate(dates?.[0]);
    const formattedEnd = formatDate(dates?.[1]);

    setFilterDate({
      startDate: formattedStart,
      endDate: formattedEnd,
    });
  };

  const handleCreateOrder = () => {
    navigate(`/company/${companyId}/order/create`);
  };

  const handleBookingSubmit = async (values) => {
    setBookingLoading(true);
    try {
      const bookingData = {
        name: values.name,
        email: values.email,
        mobile: values.mobile,
        appointmentDate: values.appointmentDate.format('DD/MM/YYYY'),
        appointmentTime: values.appointmentTime.format('HH:mm'),
        totalPerson: values.totalPerson,
        status: 'pending',
        companyId:companyId
      };

      let res = await createAppoinment(bookingData)
      if(!res?.success) return toast.error(res?.message||'error while create booking!')
      toast.success(res?.message||'booking created sucessfully!')
      
      setBookingModalVisible(false);
      form.resetFields();
      getCompanyDashReports();
      getAppointmentStats();
      
    } catch (error) {
      console.error('Error creating booking:', error);
      message.error(error.message || 'Failed to create booking. Please try again.');
    } finally {
      setBookingLoading(false);
    }
  };

  const handleViewMonthlyBookings = () => {
    setMonthlyBookingsVisible(true)
    fetchMonthlyBookings()
  }

  const handleEditBooking = (booking) => {
    setSelectedBooking(booking)
    editForm.setFieldsValue({
      ...booking,
      appointmentDate: moment(booking.appointmentDate),
      appointmentTime: moment(booking.appointmentTime, 'HH:mm')
    })
    setEditBookingModal(true)
  }

  const handleUpdateBooking = async (values) => {
    try {
      const updateData = {
        ...values,
        appointmentDate: values.appointmentDate.format('DD/MM/YYYY'),
        appointmentTime: values.appointmentTime.format('HH:mm'),
      }
      
      const res = await updateAppoinment(selectedBooking._id, updateData)
      
      if (!res?.success) {
        message.error(res?.message || 'Failed to update booking')
        return
      }
      
      message.success('Booking updated successfully!')
      setEditBookingModal(false)
      fetchMonthlyBookings()
      getAppointmentStats()
      
    } catch (error) {
      console.error('Error updating booking:', error)
      message.error('Failed to update booking')
    }
  }

  const handleStatusUpdate = async (bookingId, newStatus) => {
    try {
      const res = await updateAppoinmentStatus(bookingId, newStatus)
      
      if (!res?.success) {
        toast.error(res?.message || 'Failed to update status')
        return
      }
      
      toast.success(`Appointment ${newStatus} successfully!`)
      fetchMonthlyBookings()
      getAppointmentStats()
      
    } catch (error) {
      console.error('Error updating status:', error)
      message.error('Failed to update status')
    }
  }

  const handleCreateOrderFromBooking = (booking) => {
    setSelectedBooking(booking)
    setCreateOrderModal(true)
    fetchServices()
    fetchStaff()
    // Reset search and filters when opening modal
    setServiceSearchTerm('')
    setServicePriceFilter(null)
    setServiceSortBy('name')
  }

  const handleServiceToggle = (service) => {
    setSelectedServices(prev => {
      const exists = prev.find(s => s._id === service._id)
      if (exists) {
        return prev.filter(s => s._id !== service._id)
      } else {
        return [...prev, service]
      }
    })
  }

  const getTotalAmount = () => {
    return selectedServices.reduce((sum, service) => sum + service.price, 0)
  }

  const handlePlaceOrder = async (values) => {
    try {
      setOrderLoading(true)
      
      let staff = staffList.find(x=>x._id===values?.staff.userId)
      console.log(selectedBooking,"selectedBooking")
      // return 
      const orderData = {
        ...values,
        clientName: selectedBooking.name,
        number: selectedBooking.mobile,
        email: selectedBooking.email,
        totalAmount: getTotalAmount(),
        serviceList: selectedServices.map((s) => ({
          id: s._id,
          name: s.name,
          price: s.price,
        })),
        type: 'scheduled',
        appoinmentDate: moment(selectedBooking.appointmentDate).format("DD/MM/YYYY"),
        appoinmentTime: selectedBooking.appointmentTime,
         appointmentDate: selectedBooking.appointmentDate,
        appointmentTime: selectedBooking.appointmentTime,
        staff:{
          userId:staff?._id,
          userName:staff?.name
        },
        companyId:companyId,
        scheduledBookingId:selectedBooking?._id
      }
      
      const res = await createOrderApi(companyId, orderData);
      await handleStatusUpdate(selectedBooking?._id,'completed')
      if (!res?.success) {
        toast.error(res?.message || 'Failed to create order!');
        return;
      }
      
      toast.success('Order created successfully!');
      setCreateOrderModal(false);
      setSelectedServices([]);
      
    } catch (error) {
      console.error('Error creating order:', error)
      message.error('Failed to create order')
    } finally {
      setOrderLoading(false)
    }
  }

  const disabledDate = (current) => {
    return current && current < moment().startOf('day');
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'pending': return 'orange'
      case 'completed': return 'green'
      case 'cancelled': return 'red'
      default: return 'default'
    }
  }

  const bookingColumns = [
    {
      title: 'Client Details',
      key: 'client',
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>{record.name}</div>
          <div style={{ fontSize: 12, color: '#666' }}>{record.email}</div>
          <div style={{ fontSize: 12, color: '#666' }}>{record.mobile}</div>
        </div>
      ),
    },
    {
      title: 'Date & Time',
      key: 'datetime',
      render: (_, record) => (
        <div>
          <div>{moment(record.appointmentDate).format('DD MMM YYYY')}</div>
          <div style={{ fontSize: 12, color: '#666' }}>{record.appointmentTime}</div>
        </div>
      ),
    },
    {
      title: 'Persons',
      dataIndex: 'totalPerson',
      key: 'totalPerson',
      align: 'center',
      render: (count) => (
        <Badge count={count} style={{ backgroundColor: '#52c41a' }} />
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={getStatusColor(status)} style={{ textTransform: 'capitalize' }}>
          {status}
        </Tag>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Dropdown
          menu={{
            items: [
              {
                key: 'edit',
                icon: <EditOutlined />,
                label: 'Edit Details',
                onClick: () => handleEditBooking(record),
              },
              {
                key: 'order',
                icon: <ShoppingCartOutlined />,
                label: 'Create Order',
                onClick: () => handleCreateOrderFromBooking(record),
              },
              {
                type: 'divider',
              },
              {
                key: 'complete',
                icon: <CheckCircleOutlined />,
                label: 'Mark Complete',
                onClick: () => handleStatusUpdate(record._id, 'completed'),
                disabled: record.status === 'completed',
              },
              {
                key: 'cancel',
                icon: <CloseCircleOutlined />,
                label: 'Cancel',
                danger: true,
                onClick: () => handleStatusUpdate(record._id, 'cancelled'),
                disabled: record.status === 'cancelled',
              },
            ],
          }}
          trigger={['click']}
        >
          <Button type="text" icon={<MoreOutlined />} />
        </Dropdown>
      ),
    },
  ];

  return (
    <div style={{ padding: '16px', backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '20px',
        backgroundColor: 'white',
        padding: '16px 20px',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        flexWrap: 'wrap',
        gap: '12px'
      }}>
        <h1 style={{ 
          margin: 0, 
          fontSize: window.innerWidth < 768 ? '20px' : '24px', 
          fontWeight: '600', 
          color: '#1f2937',
          minWidth: 'fit-content'
        }}>
          Company Dashboard
        </h1>
        <RangePicker
          onChange={handleChange}
          style={{ 
            width: window.innerWidth < 768 ? '100%' : '280px',
            minWidth: '240px'
          }}
        />
         <Button
      type="primary"
      icon={<DownloadOutlined />}
      onClick={downloadReport}
      loading={loading}
      style={{
        borderRadius: '8px',
        fontWeight: '500',
        boxShadow: '0 2px 6px rgba(24, 144, 255, 0.3)'
      }}
    >
      {window.innerWidth < 768 ? '' : 'Download Report'}
    </Button>
      </div>

      {/* Stats Cards */}
      <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        <Col xs={24} sm={6}>
          <Card 
            loading={loading}
            style={{ 
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              border: 'none'
            }}
            bodyStyle={{ padding: '20px' }}
          >
            <Statistic
              title={<span style={{ fontSize: '20px', color: '#6b7280' }}>Total Amount</span>}
              value={reports.totalAmount || 0}
              precision={0}
              valueStyle={{ 
                color: '#059669', 
                fontSize: window.innerWidth < 768 ? '20px' : '24px', 
                fontWeight: '700' 
              }}
              // prefix={<DollarCircleOutlined style={{ fontSize: '18px' }} />}
              prefix={<p>INR</p>}

            />
          </Card>
        </Col>

        {/* <Col xs={24} sm={6}>
          <Card 
            loading={loading}
            style={{ 
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              border: 'none'
            }}
            bodyStyle={{ padding: '20px' }}
          >
            <Statistic
              title={<span style={{ fontSize: '14px', color: '#6b7280' }}>Repeat Clients</span>}
              value={reports.repeatClients || 0}
              valueStyle={{ 
                color: '#3b82f6', 
                fontSize: window.innerWidth < 768 ? '20px' : '24px', 
                fontWeight: '700' 
              }}
              prefix={<UserOutlined style={{ fontSize: '18px' }} />}
            />
          </Card>
        </Col> */}

        <Col xs={24} sm={6}>
          <Card 
            loading={appointmentsLoading}
            hoverable
            onClick={handleViewMonthlyBookings}
            style={{ 
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            bodyStyle={{ padding: '20px' }}
          >
            <Statistic
              title={<span style={{ fontSize: '20px', color: '#6b7280' }}>This Month</span>}
              value={appointments.totalThisMonth || 0}
              valueStyle={{ 
                color: '#8b5cf6', 
                fontSize: window.innerWidth < 768 ? '20px' : '24px', 
                fontWeight: '700' 
              }}
              prefix={<CalendarOutlined style={{ fontSize: '18px' }} />}
              suffix="bookings"
            />
            <div style={{ 
              marginTop: '8px', 
              fontSize: '12px', 
              color: '#8b5cf6',
              fontWeight: '500'
            }}>
              Click to view all
            </div>
          </Card>
        </Col>

        <Col xs={24} sm={6}>
          <Card 
            loading={appointmentsLoading}
            style={{ 
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              border: 'none'
            }}
            bodyStyle={{ padding: '20px' }}
          >
            <Statistic
              title={<span style={{ fontSize: '20px', color: '#6b7280' }}>Today</span>}
              value={appointments.totalToday || 0}
              valueStyle={{ 
                color: '#f59e0b', 
                fontSize: window.innerWidth < 768 ? '20px' : '24px', 
                fontWeight: '700' 
              }}
              prefix={<ClockCircleOutlined style={{ fontSize: '18px' }} />}
              suffix="bookings"
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6} lg={4}>
    <Card 
      loading={loading}
      style={{ 
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        border: 'none'
      }}
      bodyStyle={{ padding: '20px' }}
    >
      <Statistic
        title={<span style={{ fontSize: '20px', color: '#6b7280' }}>Online Payment</span>}
        value={reports?.paymentModeStats?.online?.amount || 0}
        precision={0}
        valueStyle={{ 
          color: '#10b981', 
          fontSize: window.innerWidth < 768 ? '18px' : '22px', 
          fontWeight: '700' 
        }}
        prefix={<CreditCardOutlined style={{ fontSize: '16px' }} />}
      />
    </Card>
  </Col>
        <Col xs={24} sm={12} md={6} lg={4}>
    <Card 
      loading={loading}
      style={{ 
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        border: 'none'
      }}
      bodyStyle={{ padding: '20px' }}
    >
      <Statistic
        title={<span style={{ fontSize: '20px', color: '#6b7280' }}>Cash Payment</span>}
        value={reports?.paymentModeStats?.cash?.amount || 0}
        precision={0}
        valueStyle={{ 
          color: '#f59e0b', 
          fontSize: window.innerWidth < 768 ? '18px' : '22px', 
          fontWeight: '700' 
        }}
        prefix={<WalletOutlined style={{ fontSize: '16px' }} />}
      />
    </Card>
  </Col>
      </Row>

      {/* Top Service Card */}
      {/* <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        <Col xs={24}>
          <Card 
            loading={loading}
            style={{ 
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              border: 'none'
            }}
            bodyStyle={{ padding: '20px' }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              <StarOutlined style={{ fontSize: '20px', color: '#f59e0b', marginRight: '12px' }} />
              <span style={{ fontSize: '16px', color: '#6b7280', fontWeight: '500' }}>Top Service</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ 
                  fontSize: '18px', 
                  fontWeight: '600', 
                  color: '#1f2937',
                  textTransform: 'capitalize'
                }}>
                  {reports.topService?.name || 'No data'}
                </div>
                <div style={{ 
                  fontSize: '14px', 
                  color: '#6b7280' 
                }}>
                  {reports.topService?.count || 0} orders
                </div>
              </div>
            </div>
          </Card>
        </Col>
      </Row> */}

      {/* Today's Bookings Section */}
      {appointments.todaysBookings.length > 0 && (
        <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
          <Col xs={24}>
            <Card 
              style={{ 
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                border: 'none'
              }}
              bodyStyle={{ padding: '20px' }}
            >
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                marginBottom: '16px' 
              }}>
                <h3 style={{ 
                  margin: 0, 
                  fontSize: '18px', 
                  fontWeight: '600', 
                  color: '#1f2937',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  <CalendarOutlined style={{ marginRight: '8px', color: '#3b82f6' }} />
                  Today's Appointments ({appointments.todaysBookings.length})
                </h3>
              </div>
              
              <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {appointments.todaysBookings.map((booking, index) => (
                  <div 
                    key={booking._id || index}
                    style={{
                      padding: '16px',
                      backgroundColor: '#f8fafc',
                      borderRadius: '8px',
                      marginBottom: '12px',
                      border: '1px solid #e2e8f0',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <Row justify="space-between" align="middle">
                      <Col xs={24} sm={16}>
                        <div style={{ flex: 1 }}>
                          <div style={{ 
                            fontWeight: '600', 
                            color: '#1f2937',
                            fontSize: '16px',
                            marginBottom: '4px'
                          }}>
                            {booking.name}
                          </div>
                          <div style={{ 
                            fontSize: '14px', 
                            color: '#6b7280',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            marginBottom: '8px'
                          }}>
                            <span>
                              <ClockCircleOutlined style={{ marginRight: '4px' }} />
                              {booking.appointmentTime}
                            </span>
                            <span>
                              <TeamOutlined style={{ marginRight: '4px' }} />
                              {booking.totalPerson} {booking.totalPerson === 1 ? 'person' : 'people'}
                            </span>
                          </div>
                          <div style={{ 
                            fontSize: '12px', 
                            color: '#6b7280'
                          }}>
                            <div>{booking.email}</div>
                            <div>{booking.mobile}</div>
                          </div>
                        </div>
                      </Col>
                      
                      <Col xs={24} sm={8} style={{ textAlign: 'right' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px', flexWrap: 'wrap' }}>
                          <Tag color={getStatusColor(booking.status)} style={{ textTransform: 'capitalize' }}>
                            {booking.status || 'pending'}
                          </Tag>
                          
                          <Button
                            type="primary"
                            size="small"
                            icon={<ShoppingCartOutlined />}
                            onClick={() => handleCreateOrderFromBooking(booking)}
                            style={{ borderRadius: '6px' }}
                          >
                            Create Order
                          </Button>
                          
                          <Dropdown
                            menu={{
                              items: [
                                {
                                  key: 'edit',
                                  icon: <EditOutlined />,
                                  label: 'Edit',
                                  onClick: () => handleEditBooking(booking),
                                },
                                {
                                  key: 'complete',
                                  icon: <CheckCircleOutlined />,
                                  label: 'Complete',
                                  onClick: () => handleStatusUpdate(booking._id, 'completed'),
                                  disabled: booking.status === 'completed',
                                },
                                {
                                  key: 'cancel',
                                  icon: <CloseCircleOutlined />,
                                  label: 'Cancel',
                                  danger: true,
                                  onClick: () => handleStatusUpdate(booking._id, 'cancelled'),
                                  disabled: booking.status === 'cancelled',
                                },
                              ],
                            }}
                            trigger={['click']}
                          >
                            <Button type="text" icon={<MoreOutlined />} />
                          </Dropdown>
                        </div>
                      </Col>
                    </Row>
                  </div>
                ))}
              </div>
            </Card>
          </Col>
        </Row>
      )}

      {/* Action Buttons */}
      <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
        <Col xs={24} sm={12}>
          <Button 
            type="primary" 
            size="large"
            icon={<PlusOutlined />}
            onClick={handleCreateOrder}
            block
            style={{
              height: '48px',
              fontSize: '16px',
              fontWeight: '500',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)'
            }}
          >
            Create New Order
          </Button>
        </Col>
        <Col xs={24} sm={12}>
          <Button 
            type="default" 
            size="large"
            icon={<CalendarOutlined />}
            onClick={() => setBookingModalVisible(true)}
            block
            style={{
              height: '48px',
              fontSize: '16px',
              fontWeight: '500',
              borderRadius: '8px',
              borderColor: '#d1d5db',
              color: '#374151'
            }}
          >
            Book Appointment
          </Button>
        </Col>
      </Row>
      <div style={{
        marginTop:'10px'
      }}>
      <ExpensesOverview/>
      </div>

      {/* Monthly Bookings Modal */}
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <HistoryOutlined style={{ marginRight: '8px', color: '#8b5cf6' }} />
            Monthly Bookings - {moment().format('MMMM YYYY')}
          </div>
        }
        open={monthlyBookingsVisible}
        onCancel={() => setMonthlyBookingsVisible(false)}
        width="90%"
        style={{ top: 20 }}
        footer={null}
      >
        <Table
          dataSource={monthlyBookings}
          columns={bookingColumns}
          loading={monthlyBookingsLoading}
          rowKey="_id"
          pagination={{ pageSize: 10 }}
          style={{ marginTop: 16 }}
        />
      </Modal>

      {/* Edit Booking Modal */}
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <EditOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
            Edit Appointment
          </div>
        }
        open={editBookingModal}
        onCancel={() => setEditBookingModal(false)}
        footer={null}
        width={500}
      >
        <Form
          form={editForm}
          layout="vertical"
          onFinish={handleUpdateBooking}
          style={{ marginTop: 16 }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Client Name"
                rules={[{ required: true, message: 'Please enter client name' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ type: 'email', message: 'Please enter valid email' }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="mobile"
                label="Mobile"
                rules={[{ required: true, message: 'Please enter mobile number' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="totalPerson"
                label="Total Persons"
                rules={[{ required: true, message: 'Please enter number of persons' }]}
              >
                <InputNumber min={1} max={20} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>
          
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="appointmentDate"
                label="Appointment Date"
                rules={[{ required: true, message: 'Please select date' }]}
              >
                <DatePicker 
                  style={{ width: '100%' }}
                  disabledDate={disabledDate}
                  format="DD/MM/YYYY"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="appointmentTime"
                label="Appointment Time"
                rules={[{ required: true, message: 'Please select time' }]}
              >
                <TimePicker 
                  style={{ width: '100%' }}
                  format="HH:mm"
                  minuteStep={15}
                />
              </Form.Item>
            </Col>
          </Row>
          
          <Form.Item
            name="status"
            label="Status"
          >
            <Select>
              <Option value="pending">Pending</Option>
              <Option value="completed">Completed</Option>
              <Option value="cancelled">Cancelled</Option>
            </Select>
          </Form.Item>

          <div style={{ textAlign: 'right', marginTop: 24 }}>
            <Button onClick={() => setEditBookingModal(false)} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Update Appointment
            </Button>
          </div>
        </Form>
      </Modal>

      {/* Create Order from Booking Modal - Enhanced for 500+ products */}
      <Modal
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ShoppingCartOutlined style={{ marginRight: '8px', color: '#52c41a' }} />
            Create Order for {selectedBooking?.name}
          </div>
        }
        open={createOrderModal}
        onCancel={() => {
          setCreateOrderModal(false)
          setSelectedServices([])
          setServiceSearchTerm('')
        }}
        width={1000}
        style={{ top: 20 }}
        footer={null}
      >
        {selectedBooking && (
          <div>
            {/* Client Info */}
            <Card size="small" style={{ marginBottom: 16, backgroundColor: '#f6ffed' }}>
              <Row gutter={16}>
                <Col span={8}>
                  <Text strong>Client:</Text> {selectedBooking.name}
                </Col>
                <Col span={8}>
                  <Text strong>Date:</Text> {moment(selectedBooking.appointmentDate).format('DD MMM YYYY')}
                </Col>
                <Col span={8}>
                  <Text strong>Time:</Text> {selectedBooking.appointmentTime}
                </Col>
              </Row>
            </Card>

            {/* Enhanced Services Selection */}
            <Card size="small" style={{ marginBottom: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <Title level={5} style={{ margin: 0 }}>Select Services</Title>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <Text type="secondary">
                    {filteredServices.length} of {services.length} services
                  </Text>
                  {selectedServices.length > 0 && (
                    <Badge count={selectedServices.length} style={{ backgroundColor: '#52c41a' }}>
                      <Button 
                        type="link" 
                        onClick={() => setSelectedServices([])}
                        style={{ padding: 0, fontSize: 12 }}
                      >
                        Clear All
                      </Button>
                    </Badge>
                  )}
                </div>
              </div>

              {/* Advanced Search and Filters */}
              <div style={{ marginBottom: 16, padding: 16, backgroundColor: '#fafafa', borderRadius: 8 }}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={12}>
                    <Input.Search
                      placeholder="Search services by name..."
                      value={serviceSearchTerm}
                      onChange={(e) => setServiceSearchTerm(e.target.value)}
                      allowClear
                      size="large"
                      style={{ width: '100%' }}
                    />
                  </Col>
                  <Col xs={24} md={6}>
                    <Select
                      placeholder="Filter by price range"
                      value={servicePriceFilter}
                      onChange={setServicePriceFilter}
                      style={{ width: '100%' }}
                      size="large"
                      allowClear
                    >
                      <Option value="0-500">₹0 - ₹500</Option>
                      <Option value="500-1000">₹500 - ₹1,000</Option>
                      <Option value="1000-2000">₹1,000 - ₹2,000</Option>
                      <Option value="2000-5000">₹2,000 - ₹5,000</Option>
                      <Option value="5000+">₹5,000+</Option>
                    </Select>
                  </Col>
                  <Col xs={24} md={6}>
                    <Select
                      placeholder="Sort by"
                      value={serviceSortBy}
                      onChange={setServiceSortBy}
                      style={{ width: '100%' }}
                      size="large"
                    >
                      <Option value="name">Name A-Z</Option>
                      <Option value="name-desc">Name Z-A</Option>
                      <Option value="price">Price Low-High</Option>
                      <Option value="price-desc">Price High-Low</Option>
                    </Select>
                  </Col>
                </Row>
              </div>

              {/* Services Grid with Virtual Scrolling */}
              <div style={{ 
                height: 400, 
                border: '1px solid #f0f0f0', 
                borderRadius: 8,
                overflow: 'hidden'
              }}>
                {filteredServices.length === 0 ? (
                  <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    height: '100%',
                    color: '#999'
                  }}>
                    <SearchOutlined style={{ fontSize: 48, marginBottom: 16, color: '#d9d9d9' }} />
                    <Text type="secondary">
                      {serviceSearchTerm || servicePriceFilter ? 'No services match your search criteria' : 'No services available'}
                    </Text>
                    {(serviceSearchTerm || servicePriceFilter) && (
                      <Button 
                        type="link" 
                        onClick={() => {
                          setServiceSearchTerm('')
                          setServicePriceFilter(null)
                        }}
                        style={{ marginTop: 8 }}
                      >
                        Clear filters
                      </Button>
                    )}
                  </div>
                ) : (
                  <List
                    dataSource={filteredServices}
                    renderItem={(service, index) => {
                      const isSelected = selectedServices.find(s => s._id === service._id)
                      return (
                        <List.Item
                          key={service._id}
                          style={{
                            padding: '12px 16px',
                            margin: '4px 8px',
                            borderRadius: 8,
                            border: isSelected ? '2px solid #52c41a' : '1px solid #f0f0f0',
                            backgroundColor: isSelected ? '#f6ffed' : 'white',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                          }}
                          onClick={() => handleServiceToggle(service)}
                        >
                          <List.Item.Meta
                            avatar={
                              <div style={{ 
                                width: 48, 
                                height: 48, 
                                borderRadius: '50%',
                                background: service.image?.fileUrl ? 'transparent' : 'linear-gradient(45deg, #1890ff, #722ed1)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: 16,
                                overflow: 'hidden'
                              }}>
                                {service.image?.fileUrl ? (
                                  <img 
                                    src={service.image.fileUrl} 
                                    alt={service.name}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                  />
                                ) : (
                                  service.name.charAt(0).toUpperCase()
                                )}
                              </div>
                            }
                            title={
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{ 
                                  fontWeight: 600, 
                                  color: isSelected ? '#52c41a' : '#1f2937',
                                  fontSize: 16
                                }}>
                                  {service.name}
                                </span>
                                {isSelected && (
                                  <CheckCircleOutlined style={{ color: '#52c41a', fontSize: 20 }} />
                                )}
                              </div>
                            }
                            description={
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Text type="secondary" style={{ fontSize: 12 }}>
                                  {service.description || 'Professional service'}
                                </Text>
                                <Text strong style={{ 
                                  color: '#52c41a', 
                                  fontSize: 16,
                                  fontWeight: 'bold'
                                }}>
                                  ₹{service.price}
                                </Text>
                              </div>
                            }
                          />
                        </List.Item>
                      )
                    }}
                    style={{ 
                      height: '100%', 
                      overflowY: 'auto',
                      padding: '8px 0'
                    }}
                    pagination={false}
                  />
                )}
              </div>
            </Card>

            {/* Selected Services Summary - Enhanced */}
            {selectedServices.length > 0 && (
              <Card size="small" style={{ marginBottom: 16, backgroundColor: '#f0f9ff', border: '2px solid #1890ff' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <Title level={5} style={{ margin: 0, color: '#1890ff' }}>
                    Selected Services ({selectedServices.length})
                  </Title>
                  <Button 
                    type="text" 
                    size="small"
                    onClick={() => setSelectedServices([])}
                    style={{ color: '#1890ff' }}
                  >
                    Clear All
                  </Button>
                </div>
                
                <div style={{ maxHeight: 120, overflowY: 'auto' }}>
                  {selectedServices.map(service => (
                    <div 
                      key={service._id} 
                      style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        padding: '6px 12px',
                        margin: '4px 0',
                        backgroundColor: 'white',
                        borderRadius: 6,
                        border: '1px solid #d6f7ff'
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <Text strong style={{ fontSize: 14 }}>{service.name}</Text>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Text strong style={{ color: '#52c41a' }}>₹{service.price}</Text>
                        <Button
                          type="text"
                          size="small"
                          icon={<CloseOutlined />}
                          onClick={(e) => {
                            e.stopPropagation()
                            handleServiceToggle(service)
                          }}
                          style={{ 
                            color: '#ff4d4f',
                            padding: 0,
                            width: 20,
                            height: 20,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                
                <Divider style={{ margin: '12px 0' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 16, fontWeight: 'bold' }}>
                  <span>Total Amount:</span>
                  <span style={{ color: '#1890ff', fontSize: 18 }}>₹{getTotalAmount()}</span>
                </div>
              </Card>
            )}

            {/* Staff Selection Form */}
            <Form onFinish={handlePlaceOrder} layout="vertical">
              <Form.Item
                name={["staff", "userId"]}
                label="Select Staff"
                rules={[{ required: true, message: "Please select staff" }]}
              >
                <Select
                  placeholder="Select staff member"
                  size="large"
                  showSearch
                  filterOption={(input, option) =>
                    option.children.props.children[1].props.children[0].toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={(value) => {
                    const staff = staffList.find(s => s._id === value)
                    // You can set staff name in hidden field if needed
                  }}
                >
                  {staffList.map((user) => (
                    <Option key={user._id} value={user._id}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar size="small" icon={<UserOutlined />} style={{ marginRight: 8 }} />
                        <div>
                          <div>{user.name}</div>
                          <Text type="secondary" style={{ fontSize: 12 }}>{user.email}</Text>
                        </div>
                      </div>
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                padding: '16px 0',
                borderTop: '1px solid #f0f0f0'
              }}>
                <div>
                  <Text type="secondary">
                    {selectedServices.length} service{selectedServices.length !== 1 ? 's' : ''} selected
                  </Text>
                  <br />
                  <Text strong style={{ fontSize: 18, color: '#1890ff' }}>
                    Total: ₹{getTotalAmount()}
                  </Text>
                </div>
                
                <div style={{ display: 'flex', gap: 12 }}>
                  <Button 
                    onClick={() => {
                      setCreateOrderModal(false)
                      setSelectedServices([])
                      setServiceSearchTerm('')
                    }}
                    size="large"
                  >
                    Cancel
                  </Button>
                  <Button 
                    type="primary" 
                    htmlType="submit"
                    loading={orderLoading}
                    disabled={selectedServices.length === 0}
                    size="large"
                    style={{ 
                      background: '#52c41a', 
                      borderColor: '#52c41a',
                      minWidth: 140
                    }}
                  >
                    Create Order
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        )}
      </Modal>

      {/* Users Section */}
      <div style={{ marginTop: 24 }}>
        <Card
          title={
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <TeamOutlined style={{ color: '#1890ff' }} />
              <span style={{ fontWeight: 600, fontSize: 16 }}>Users</span>
            </div>
          }
          extra={
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <Input
                placeholder="Search name, email or phone"
                prefix={<SearchOutlined />}
                value={memberSearch}
                onChange={e => setMemberSearch(e.target.value)}
                style={{ width: 240 }}
                allowClear
              />
              <Button
                icon={<DownloadOutlined />}
                onClick={downloadMembersCSV}
                disabled={members.length === 0}
              >
                Download CSV
              </Button>
            </div>
          }
          style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.07)' }}
        >
          <Table
            dataSource={members.filter(m => {
              if (!memberSearch) return true
              const q = memberSearch.toLowerCase()
              return (
                (m.name || '').toLowerCase().includes(q) ||
                (m.email || '').toLowerCase().includes(q) ||
                (m.phone || '').toLowerCase().includes(q)
              )
            })}
            rowKey="_id"
            loading={membersLoading}
            pagination={{ pageSize: 10, showTotal: total => `Total ${total} users` }}
            scroll={{ x: 800 }}
            columns={[
              {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                render: (name) => (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Avatar icon={<UserOutlined />} size="small" style={{ backgroundColor: '#1890ff' }} />
                    <Text strong>{name}</Text>
                  </div>
                ),
              },
              {
                title: 'Email',
                dataIndex: 'email',
                key: 'email',
                render: (email) => <Text type="secondary">{email || '—'}</Text>,
              },
              {
                title: 'Phone',
                dataIndex: 'phone',
                key: 'phone',
                render: (phone) => <Text>{phone || '—'}</Text>,
              },
              {
                title: 'Total Visits',
                dataIndex: 'totalVisits',
                key: 'totalVisits',
                align: 'center',
                sorter: (a, b) => (a.totalVisits || 0) - (b.totalVisits || 0),
                render: (v) => (
                  <Tag color="blue" icon={<HistoryOutlined />}>{v || 0}</Tag>
                ),
              },
              {
                title: 'Total Spent',
                dataIndex: 'totalSpent',
                key: 'totalSpent',
                align: 'center',
                sorter: (a, b) => (a.totalSpent || 0) - (b.totalSpent || 0),
                render: (v) => (
                  <Text strong style={{ color: '#52c41a' }}>₹{v || 0}</Text>
                ),
              },
              {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                align: 'center',
                render: (status) => (
                  <Tag color={status === 'active' ? 'success' : 'error'}>
                    {status === 'active' ? 'Active' : 'Inactive'}
                  </Tag>
                ),
              },
              {
                title: 'Joined',
                dataIndex: 'createdAt',
                key: 'createdAt',
                render: (date) => moment(date).format('DD MMM YYYY'),
              },
              {
                title: 'Action',
                key: 'action',
                align: 'center',
                render: (_, record) => (
                  <Button
                    type="link"
                    icon={<FileTextOutlined />}
                    onClick={() => openHistoryDrawer(record)}
                  >
                    View History
                  </Button>
                ),
              },
            ]}
          />
        </Card>
      </div>

      {/* User History Drawer */}
      <Drawer
        title={
          selectedMember && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
              <div>
                <div style={{ fontWeight: 600 }}>{selectedMember.name}</div>
                <div style={{ fontSize: 12, color: '#888', fontWeight: 400 }}>
                  {selectedMember.email} &nbsp;|&nbsp; {selectedMember.phone}
                </div>
              </div>
            </div>
          )
        }
        open={historyDrawerOpen}
        onClose={() => { setHistoryDrawerOpen(false); setSelectedMember(null); setMemberHistory([]) }}
        width={520}
        extra={
          selectedMember && (
            <div style={{ display: 'flex', gap: 16 }}>
              <Statistic title="Visits" value={selectedMember.totalVisits || 0} prefix={<HistoryOutlined />} valueStyle={{ fontSize: 16 }} />
              <Statistic title="Total Spent" value={`₹${selectedMember.totalSpent || 0}`} valueStyle={{ fontSize: 16, color: '#52c41a' }} />
            </div>
          )
        }
      >
        {historyLoading ? (
          <div style={{ textAlign: 'center', paddingTop: 60 }}>
            <Spin size="large" />
          </div>
        ) : memberHistory.length === 0 ? (
          <div style={{ textAlign: 'center', paddingTop: 60, color: '#aaa' }}>
            <HistoryOutlined style={{ fontSize: 40, marginBottom: 12 }} />
            <div>No visit history found</div>
          </div>
        ) : (
          <List
            dataSource={memberHistory}
            renderItem={(item, idx) => (
              <List.Item key={idx} style={{ padding: '12px 0' }}>
                <div style={{ width: '100%' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                    <Text strong>{item.serviceName || 'Service'}</Text>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                      {item.usedAt ? moment(item.usedAt).format('DD MMM YYYY, hh:mm A') : '—'}
                    </Text>
                  </div>
                  <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                    {item.staffName && (
                      <Tag icon={<UserOutlined />} color="geekblue">{item.staffName}</Tag>
                    )}
                    {item.orderId && (
                      <Tag icon={<ShoppingCartOutlined />} color="purple">Order linked</Tag>
                    )}
                  </div>
                </div>
              </List.Item>
            )}
          />
        )}
      </Drawer>

      {/* New Booking Modal */}
      <Modal
        title={
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            fontSize: '20px', 
            fontWeight: '600',
            color: '#1f2937'
          }}>
            <UserAddOutlined style={{ marginRight: '8px', color: '#3b82f6' }} />
            Book New Appointment
          </div>
        }
        open={bookingModalVisible}
        onCancel={() => {
          setBookingModalVisible(false);
          form.resetFields();
        }}
        footer={null}
        width={window.innerWidth < 768 ? '95%' : 600}
        style={{ top: window.innerWidth < 768 ? 20 : 50 }}
        bodyStyle={{ 
          padding: window.innerWidth < 768 ? '16px' : '24px',
          maxHeight: window.innerWidth < 768 ? '80vh' : 'none',
          overflowY: 'auto'
        }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleBookingSubmit}
          style={{ marginTop: '16px' }}
          requiredMark={false}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12}>
              <Form.Item
                label={
                  <span style={{ fontWeight: '500', color: '#374151' }}>
                    <UserOutlined style={{ marginRight: '6px' }} />
                    Full Name
                  </span>
                }
                name="name"
                rules={[{ required: true, message: 'Please enter full name' }]}
              >
                <Input 
                  placeholder="Enter full name" 
                  size="large"
                  style={{ borderRadius: '8px' }}
                />
              </Form.Item>
            </Col>
            
            <Col xs={24} sm={12}>
              <Form.Item
                label={
                  <span style={{ fontWeight: '500', color: '#374151' }}>
                    <MailOutlined style={{ marginRight: '6px' }} />
                    Email Address
                  </span>
                }
                name="email"
                rules={[
                  { required: true, message: 'Please enter email address' },
                  { type: 'email', message: 'Please enter a valid email' }
                ]}
              >
                <Input 
                  placeholder="Enter email address" 
                  size="large"
                  style={{ borderRadius: '8px' }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12}>
              <Form.Item
                label={
                  <span style={{ fontWeight: '500', color: '#374151' }}>
                    <PhoneOutlined style={{ marginRight: '6px' }} />
                    Mobile Number
                  </span>
                }
                name="mobile"
                rules={[{ required: true, message: 'Please enter mobile number' }]}
              >
                <Input 
                  placeholder="Enter mobile number" 
                  size="large"
                  style={{ borderRadius: '8px' }}
                />
              </Form.Item>
            </Col>
            
            <Col xs={24} sm={12}>
              <Form.Item
                label={
                  <span style={{ fontWeight: '500', color: '#374151' }}>
                    <TeamOutlined style={{ marginRight: '6px' }} />
                    Total Persons
                  </span>
                }
                name="totalPerson"
                rules={[{ required: true, message: 'Please enter number of persons' }]}
              >
                <InputNumber 
                  placeholder="Number of persons"
                  min={1}
                  max={20}
                  size="large"
                  style={{ width: '100%', borderRadius: '8px' }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12}>
              <Form.Item
                label={
                  <span style={{ fontWeight: '500', color: '#374151' }}>
                    <CalendarOutlined style={{ marginRight: '6px' }} />
                    Appointment Date
                  </span>
                }
                name="appointmentDate"
                rules={[{ required: true, message: 'Please select appointment date' }]}
              >
                <DatePicker 
                  placeholder="Select date"
                  size="large"
                  style={{ width: '100%', borderRadius: '8px' }}
                  disabledDate={disabledDate}
                  format="DD/MM/YYYY"
                />
              </Form.Item>
            </Col>
            
            <Col xs={24} sm={12}>
              <Form.Item
                label={
                  <span style={{ fontWeight: '500', color: '#374151' }}>
                    <ClockCircleOutlined style={{ marginRight: '6px' }} />
                    Appointment Time
                  </span>
                }
                name="appointmentTime"
                rules={[{ required: true, message: 'Please select appointment time' }]}
              >
                <TimePicker 
                  placeholder="Select time"
                  size="large"
                  style={{ width: '100%', borderRadius: '8px' }}
                  format="HH:mm"
                  minuteStep={15}
                />
              </Form.Item>
            </Col>
          </Row>

          <div style={{ 
            display: 'flex', 
            justifyContent: 'flex-end', 
            gap: '12px',
            marginTop: '24px',
            paddingTop: '16px',
            borderTop: '1px solid #f3f4f6'
          }}>
            <Button 
              onClick={() => {
                setBookingModalVisible(false);
                form.resetFields();
              }}
              size="large"
              style={{ 
                borderRadius: '8px',
                minWidth: '80px'
              }}
            >
              Cancel
            </Button>
            <Button 
              type="primary" 
              htmlType="submit"
              loading={bookingLoading}
              size="large"
              style={{ 
                borderRadius: '8px',
                minWidth: '120px',
                boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)'
              }}
            >
              {bookingLoading ? 'Creating...' : 'Book Appointment'}
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  )
}